import { render, staticRenderFns } from "./PromotionEdit.vue?vue&type=template&id=0464762d&scoped=true"
import script from "./PromotionEdit.vue?vue&type=script&lang=js"
export * from "./PromotionEdit.vue?vue&type=script&lang=js"
import style0 from "./PromotionEdit.vue?vue&type=style&index=0&id=0464762d&prod&lang=scss&scoped=true"
import style1 from "./PromotionEdit.vue?vue&type=style&index=1&id=0464762d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0464762d",
  null
  
)

export default component.exports